export const initProductDescription = () => {
    const $blocks = $(`[data-descr]`);
    if (!$blocks.length) return;

    $blocks.each((i, block) => {
        const $block = $(block);
        const $textBlock = $block.find(`[data-descr-row]`);
        const rows = parseInt($block.attr(`data-descr`));
        const lineHeight = parseInt($textBlock.css(`line-height`));
        const height = lineHeight * rows;

        console.log(height)
        const $btn = $block.find(`[data-show-descr]`);

        if ($textBlock.height() > height) {
            $block.addClass(`hide-descr`);
        }

        $btn.on(`click`, function() {
            $(this).closest(`[data-descr]`).toggleClass(`opened`);
        });
    });
};
